module.exports = __webpack_public_path__ + "img/06.ec59fc9d.jpg";